import { FieldConfig, FormConfig, PageConfig } from "../types/formConfig";

export type DateValidationField = {
    fieldPath: string;
    pageNumber: number;
};

const visitField = (field: FieldConfig, pageNumber: number, out: DateValidationField[]) => {
    if (field.type === "date" && field.checkDateFormat && field.fieldPath) {
        out.push({ fieldPath: field.fieldPath, pageNumber });
    }
    if (field.subFields && field.subFields.length > 0) {
        for (const sub of field.subFields) visitField(sub, pageNumber, out);
    }
};

const visitPage = (page: PageConfig, out: DateValidationField[]) => {
    for (const section of page.sections) {
        for (const grid of section.grids) {
            for (const field of grid.fields) visitField(field, page.pageNumber, out);
        }
    }
};

export const collectDateValidationFields = (formConfig: FormConfig): DateValidationField[] => {
    const out: DateValidationField[] = [];
    for (const page of formConfig.pages) visitPage(page, out);
    return out;
};

const isMmDdYyyyInvalid = (value: unknown): boolean => {
    if (value == null || value === "") return false;
    const leading = parseInt(String(value).trim().slice(0, 2), 10);
    return !Number.isNaN(leading) && leading > 12;
};

export const getValueAtPath = (data: unknown, fieldPath: string): unknown => {
    if (!data || typeof data !== "object") return undefined;
    const keys = fieldPath.split(".");
    let current: any = data;
    for (const key of keys) {
        if (current == null) return undefined;
        current = current[key];
    }
    return current;
};

export const buildInvalidKey = (formType: string, pageNumber: number, fieldPath: string): string =>
    `${formType}::${pageNumber}::${fieldPath}`;

export { isMmDdYyyyInvalid };
